const c = {
  name: "InstagramSmall",
  dimensions: { width: 24, height: 24 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M9,12c0-1.6,1.3-3,3-3c1.6,0,3,1.3,3,3c0,1.6-1.3,3-3,3S9,13.6,9,12z"/>
		<path class="st0" d="M18.9,6.8c0.1,0.3,0.3,0.8,0.3,1.6c0,0.9,0.1,1.2,0.1,3.6c0,2.4,0,2.6-0.1,3.6c0,0.9-0.2,1.3-0.3,1.6
			c-0.2,0.4-0.4,0.7-0.7,1c-0.3,0.3-0.6,0.5-1,0.7c-0.3,0.1-0.8,0.3-1.6,0.3c-0.9,0-1.2,0.1-3.6,0.1c-2.4,0-2.6,0-3.6-0.1
			c-0.9,0-1.3-0.2-1.6-0.3c-0.4-0.2-0.7-0.4-1-0.7c-0.3-0.3-0.5-0.6-0.7-1c-0.1-0.3-0.3-0.8-0.3-1.6c0-0.9-0.1-1.2-0.1-3.6
			c0-2.4,0-2.6,0.1-3.6c0-0.9,0.2-1.3,0.3-1.6c0.2-0.4,0.4-0.7,0.7-1c0.3-0.3,0.6-0.5,1-0.7C7.1,5,7.6,4.8,8.4,4.8
			c0.8,0,1.1,0,2.8,0H12c2.4,0,2.6,0,3.6,0.1c0.9,0,1.3,0.2,1.6,0.3c0.4,0.2,0.7,0.4,1,0.7C18.6,6.1,18.7,6.4,18.9,6.8z M7.4,12
			c0,2.5,2,4.6,4.6,4.6c2.5,0,4.6-2,4.6-4.6c0-2.5-2-4.6-4.6-4.6C9.5,7.4,7.4,9.5,7.4,12z M15.7,7.3c0,0.6,0.5,1.1,1.1,1.1
			s1.1-0.5,1.1-1.1s-0.5-1.1-1.1-1.1S15.7,6.7,15.7,7.3z"/>
		<path class="st0" d="M23.4,2.9c0.3,0.7,0.5,1.3,0.6,2.3c0,0.2,0,3.5,0,6.8c0,3.3,0,6.6,0,6.8c-0.1,0.9-0.2,1.6-0.6,2.3
			c-0.6,1.3-1.8,2.3-3.3,2.7c-0.5,0.1-1,0.2-1.8,0.2C18,24,15,24,12,24c-3,0-6.1,0-6.4,0c-0.7,0-1.2-0.1-1.7-0.2
			c-1.4-0.4-2.6-1.4-3.3-2.7c-0.3-0.7-0.5-1.3-0.6-2.3C0,18.5,0,17,0,12V8.1c0-2.8,0-3,0.1-3.5c0,0,0,0,0,0c0.2-1.2,0.6-2.1,1.4-2.9
			c0.4-0.4,0.8-0.7,1.4-1C3.6,0.3,4.2,0.1,5.2,0C5.5,0,7,0,12,0h3.9c2.8,0,3,0,3.5,0.1l0,0c1.2,0.2,2.1,0.6,2.9,1.4
			C22.8,1.9,23.1,2.3,23.4,2.9z M20.4,17.8c0.2-0.6,0.4-1.2,0.4-2.2c0-0.9,0.1-1.2,0.1-3.7c0-2.4,0-2.7-0.1-3.7
			c0-0.9-0.2-1.6-0.4-2.2c-0.2-0.6-0.5-1.1-1-1.6c-0.5-0.5-1-0.8-1.6-1c-0.6-0.2-1.2-0.4-2.2-0.4c-0.9,0-1.2-0.1-3.7-0.1
			c-2.4,0-2.7,0-3.7,0.1c-0.9,0-1.6,0.2-2.2,0.4c-0.6,0.2-1.1,0.5-1.6,1c-0.5,0.5-0.8,1-1,1.6C3.4,6.8,3.2,7.4,3.2,8.3
			c0,0.9-0.1,1.2-0.1,3.7c0,2.4,0,2.7,0.1,3.7c0,0.9,0.2,1.6,0.4,2.2c0.2,0.6,0.5,1.1,1,1.6c0.5,0.5,1,0.8,1.6,1
			c0.6,0.2,1.2,0.4,2.2,0.4c0.9,0,1.2,0.1,3.7,0.1c2.4,0,2.7,0,3.7-0.1c0.9,0,1.6-0.2,2.2-0.4c0.6-0.2,1.1-0.5,1.6-1
			C19.9,18.9,20.2,18.4,20.4,17.8z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as InstagramSmall
};
